import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '../utils/supabaseClient'
import { Box, Card, CardContent, TextField, Button, Typography, Alert, CircularProgress } from '@mui/material'

const ResetPassword: React.FC = () => {
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [error, setError] = useState('')
  const [message, setMessage] = useState('')
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (!session) navigate('/login')
    })
  }, [navigate])

  const handleReset = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    if (password.length < 6) { setError('密码至少6个字符'); return }
    if (password !== confirmPassword) { setError('两次密码不一致'); return }
    setLoading(true)
    const { error } = await supabase.auth.updateUser({ password })
    if (error) setError(error.message)
    else { setMessage('密码重置成功！'); setTimeout(() => navigate('/'), 1500) }
    setLoading(false)
  }

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', bgcolor: '#0a0a0a' }}>
      <Card sx={{ maxWidth: 400, width: '100%', mx: 2, bgcolor: '#1a1a2e', color: '#fff' }}>
        <CardContent sx={{ p: 3 }}>
          <Typography variant="h5" align="center" gutterBottom>重置密码</Typography>
          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
          {message && <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert>}
          <form onSubmit={handleReset}>
            <TextField fullWidth label="新密码" type="password" value={password} onChange={e => setPassword(e.target.value)} margin="normal" required
              sx={{ '& .MuiInputLabel-root': { color: '#aaa' }, '& .MuiOutlinedInput-root': { color: '#fff' } }} />
            <TextField fullWidth label="确认新密码" type="password" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} margin="normal" required
              sx={{ '& .MuiInputLabel-root': { color: '#aaa' }, '& .MuiOutlinedInput-root': { color: '#fff' } }} />
            <Button fullWidth type="submit" variant="contained" disabled={loading}
              sx={{ mt: 2, bgcolor: '#e50914', '&:hover': { bgcolor: '#b20710' } }}>
              {loading ? <CircularProgress size={24} /> : '重置密码'}
            </Button>
          </form>
        </CardContent>
      </Card>
    </Box>
  )
}

export default ResetPassword
